import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, useTheme } from '@mui/material';
import { IoArrowBack } from 'react-icons/io5';

const BackButton = ({ 
  onClick, 
  size = 'medium', 
  color = 'primary',
  sx = {},
  ...props 
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    } else {
      navigate(-1);
    }
  };

  return (
    <IconButton
      onClick={handleClick}
      size={size}
      color={color}
      sx={{
        
        borderRadius: '24px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        background: `linear-gradient(135deg, ${theme.palette.primary.light}20, ${theme.palette.secondary.light}20)`,
        backdropFilter: 'blur(8px)',
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        '&:hover': {
          transform: 'translateX(-2px)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
          background: `linear-gradient(135deg, ${theme.palette.primary.light}30, ${theme.palette.secondary.light}30)`,
        },
        '&:active': {
          transform: 'translateX(-1px) scale(0.95)',
        },
        '& svg': {
          fontSize: size === 'small' ? '0.8rem' : size === 'large' ? '1.8rem' : '1.5rem',
          color: theme.palette[color]?.main || theme.palette.primary.main,
        },
        ...sx
      }}
      aria-label="Go back"
      {...props}
    >
      <IoArrowBack />
      {/* <span style={{ color: theme.palette.primary.main , fontSize: '1rem' }}> Back</span> */}
    </IconButton>
  );
};

export default BackButton; 